var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-marginless is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('card',[_c('template',{slot:"header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("Activities")])]),_c('template',{slot:"body"},[_c('activities-table',{attrs:{"user-id":_vm.userId}})],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }